import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TabList, TabPanel, Tabs } from "react-tabs";
import googleimg from "../../assets/images/review/google.png";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import registerGraphic from '../../assets/images/khojgraphics/Registration Page.png'
import fetch_axios from "axios";
import axios, { PublicKey } from "../../API/axios";
import { useGoogleLogin } from "@react-oauth/google";
import toast from "react-hot-toast";
import useLocalStorage from "use-local-storage";
import { Helmet } from "react-helmet";
import Toggle from "../../Toggle";

function SignUp() {
	const navigate = useNavigate();
	const [isDark, setIsDark] = useLocalStorage("isDark", false);
	const [showPass, setShowPass] = useState(false);
	const [showPass1, setShowPass1] = useState(false);
	const [showPass2, setShowPass2] = useState(false);
	const [showPass3, setShowPass3] = useState(false);
	const [confirmshowPass2, confirmsetShowPass2] = useState(false);
	const [confirmshowPass3, confirmsetShowPass3] = useState(false);
	const [confirmshowPass4, confirmsetShowPass4] = useState(false);
	const [showPass4, setShowPass4] = useState(false);

	const [selectedTabIndex, setSelectedTabIndex] = useState(0); // Controls active tab
	const [selectedDropdownOption, setSelectedDropdownOption] = useState(""); // Controls dropdown selection

	const handleDropdownChange = (event) => {
		console.log("event", event.target.value);

		setSelectedDropdownOption(event.target.value);
		setSelectedTabIndex(1);
		setEmail("");
		setFirstName("");
		setLastName("");
		setPassword("");
		setPassword2("");
		setPassword3("");
		setPassword4("");
		setConfirmPassword("");
		setconfirmsetPassword2("");
		setconfirmsetPassword3("");
		setconfirmsetPassword4("");
		setEmailError("");

	};
	console.log("selectedDropdownOption", selectedDropdownOption);

	//  google Api....
	const externalLogin = async (responseData) => {
		try {
			const res = await axios.post("/Auth/ContinueWithGoogle", responseData, {
				headers: {
					PublicKey,
				},
			});
			console.log("login", res.data.responseData.profile);
			toast.success(res.data.message);
			const userData = res.data.responseData.profile;
			// localStorage.setItem('firstName', userData.firstName);
			// localStorage.setItem('lastName', userData.lastName);
			localStorage.setItem("entityName", userData.entityName);
			localStorage.setItem('email', userData.email);
			localStorage.setItem('token', userData.token);
			localStorage.setItem('userUID', userData.userUID);
			localStorage.setItem('userType', userData.userType);
			localStorage.setItem('sessionId', userData.sessionId);
			localStorage.setItem('ProfileImage', userData.userImage);
			localStorage.setItem('Module', userData.userType);
			if (selectedDropdownOption === "Candidate") {
				navigate("/Home");
			} else if (selectedDropdownOption === "Institution") {
				navigate("/Home");
			} else if (selectedDropdownOption === "Company") {
				navigate("/Home");
			} else if (selectedDropdownOption === "Recruiter") {
				navigate("/Home");
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response.data.message);
			}
		}
	};

	const googleSignin = useGoogleLogin({
		onSuccess: async (tokenResponse) => {
			try {
				const resp = await fetch_axios.get(
					"https://www.googleapis.com/oauth2/v3/userinfo",
					{
						headers: {
							Authorization: `Bearer ${tokenResponse.access_token}`,
						},
					}
				);
				console.log("resp", resp);

				const responseData = {
					userType: selectedDropdownOption,
					email: resp.data.email,
					externalLoginId: resp.data.sub,
					firstName: resp.data.given_name,
					lastName: resp.data.family_name,
				};
				console.log("responseData...", responseData);

				externalLogin(responseData);
			} catch (error) {
				console.log(error);
			}
		},
	});

	//************************ Sign Up with mail  ************************//
	const [emailError, setEmailError] = useState(false);
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [passwordError, setPasswordError] = useState("");

	const [password2, setPassword2] = useState("");
	const [confirmpassword2, setconfirmsetPassword2] = useState("");
	const [password2Error, setPassword2Error] = useState("");

	const [password3, setPassword3] = useState("");
	const [confirmpassword3, setconfirmsetPassword3] = useState("");
	const [password3Error, setPassword3Error] = useState("");

	const [password4, setPassword4] = useState("");
	const [confirmpassword4, setconfirmsetPassword4] = useState("");
	const [password4Error, setPassword4Error] = useState("");

	// const [password1, setPassword1] = useState('');
	const [displays, setDisplays] = useState(false);

	//************************ Sign Up with mail  ************************//
	const validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.(com|org|in|biz)$/;
		return emailRegex.test(email);
	};

	const validatePassword = (password) => {
		const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
		return regex.test(password);
	  };

	
	  const handleInstituteChangePassword = (e) => {
		const password = e.target.value;
		setPassword2(password);
		if (!validatePassword(password)) {
		  setPassword2Error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
		} else {
		  setPassword2Error("");
		}
	  };
	  const handleCompanyChangePassword = (e) => {
		const password = e.target.value;
		setPassword3(password);
		if (!validatePassword(password)) {
		  setPassword3Error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
		} else {
		  setPassword3Error("");
		}
	  };
	  const handleReqruiterChangePassword = (e) => {
		const password = e.target.value;
		setPassword4(password);
		if (!validatePassword(password)) {
		  setPassword4Error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
		} else {
		  setPassword4Error(""); 
		}
	  };
	  const handleCandidateChangePassword = (e) => {
		const password = e.target.value;
		setPassword(password);
		if (!validatePassword(password)) {
		  setPasswordError("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
		} else {
		  setPasswordError(""); 
		}
	  };

	 

	const handleEmailChange = (e) => {
		const inputValue = e.target.value;
		setEmail(inputValue);

		if (validateEmail(inputValue)) {
			setEmailError(false);
		} else {
			setEmailError(true);
		}
	};



	const MailSignUp = async (e) => {
		e.preventDefault();
		setDisplays(true);


		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			toast.error("Please enter a valid email address.");
			return;
		}

		let data = {
			userType: selectedDropdownOption,
			email: email,
			firstName: firstName,
			lastName: lastName,
			password: password
		};
		console.log(data , "data==");
		

		if (selectedDropdownOption === "Candidate") {
			if (!firstName || !lastName || !email || !password || !confirmPassword) {
				toast.error("Please fill in all required fields for Candidate.");
				return;
			}
			if (!firstName.trim() || !lastName.trim()) {
				toast.error("Please fill proper name in Field.");
				return;
			}			
			if (password.length < 8) {
				toast.error("Password must be at least 8 characters long.");
				return;
			}
			if (!validatePassword(password)) {
				toast.error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
				return;
			}

			if (password !== confirmPassword) {
				toast.error("Passwords do not match for Candidate.");
				return;
			}
			data = { ...data, lastName: lastName, password: password };
		} else if (selectedDropdownOption === "Institution") {
			if (!firstName || !email || !password2 || !confirmpassword2) {
				toast.error("Please fill in all required fields for Institution.");
				return;
			}
			if (password2.length < 8) {
				toast.error("Password must be at least 8 characters long.");
				return;
			}
			if(!validatePassword(password2)){
				toast.error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.")
				return;
			}
			if (password2 !== confirmpassword2) {
				toast.error("Passwords do not match for Institution.");
				return;
			}
			data = { ...data, password: password2 };
		} else if (selectedDropdownOption === "Company") {
			if (!firstName || !email || !password3 || !confirmpassword3) {
				toast.error("Please fill in all required fields for Company.");
				return;
			}

			if (password3.length < 8) {
				toast.error("Password must be at least 8 characters long.");
				return;
			}

			if(!validatePassword(password3)){
				toast.error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.")
				return;
			}

			if (password3 !== confirmpassword3) {
				toast.error("Passwords do not match for Company.");
				return;
			}
			data = { ...data, password: password3 };
			
		} else if (selectedDropdownOption === "Recruiter") {
			if (!firstName || !email || !password4 || !confirmpassword4) {
				toast.error("Please fill in all required fields for Recruiter.");
				return;
			}
			if (password4.length < 8) {
				toast.error("Password must be at least 8 characters long.");
				return;
			}
			if (!validatePassword(password4)) {
				toast.error("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
				return;
			}
			if (password4 !== confirmpassword4) {
				toast.error("Passwords do not match for Recruiter.");
				return;
			}
			data = { ...data, password: password4 };
		}
		console.log('dtaaaaa', data);

		try {
			setDisplays(true);
			const resData = await axios
				.post("/Auth/SignUp", data, {
					headers: {
						PublicKey,
					},
				})
				.then((resData) => {
					console.log("resData", resData);
					toast.success(resData.data.message);
					navigate("/login");
				});
		} catch (e) {
			console.log("ee", e);
			console.error("Error during signup:", e);
			toast.error(e.response?.data?.message);
		}
	};


	return (
		<>
			<Helmet>
				<title>Register | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Register | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
			<header id="header" className="header header-default pt-3">
				<div className="container ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									{isDark ? (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo2}
													alt="sitelogo"
												/>
											</Link>
										</div>
									) : (
										<div id="logo" className="logo">
											<Link to="/">
												<img
													className="site-logo"
													id="trans-logo"
													src={logo}
													alt="sitelogo"
												/>
											</Link>
										</div>
									)}
								</div>
								<div className="header-ct-center">
									<div className="nav-wrap"></div>
								</div>
								<div className="header-ct-right">
									<div className="register-login-container me-3">
										<h3>
											Already Registered?
											<span className="login-text-color">
												<Link
													to="/login"
													className="khojLogin register-login mx-1"
												>
													Login here
												</Link>{" "}
											</span>
											
										</h3>
									</div>
									<Toggle
										isChecked={isDark}
										handleChange={() => setIsDark(!isDark)}
										className="desktopToggle"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

			<section className="account-section pt-1">
				<div className="container pt-5">
					<div className="row pt-5">
						<div className="col-md-6 registerGraphics">
							<img src={registerGraphic} alt='sitelogo' width={'100%'} />
						</div>
						<div className="col-md-6">
							<Tabs
								className="wd-form-login tf-tab"
								selectedIndex={selectedTabIndex}
								onSelect={(index) => setSelectedTabIndex(index)}
							>
								<TabPanel className="inner animation-tab create-acc-text">
									<h2>Join our Community and Start</h2>
									<h2>Exploring today.</h2>
								</TabPanel>
								<h4 className="mt-3">Create An Account</h4>
								<TabList className="menu-tab p-0  d-flex justify-content-center">
									{/* <li className={`me-4 ${selectedDropdownOption ? "bg-card-visible" : ""}`}>
										{selectedDropdownOption}
									</li> */}
									<div className="post-form-group col-8">
										<select
											className="ct-tab-dropdown"
											value={selectedDropdownOption}
											onChange={handleDropdownChange}
										>
											<option value="">Select User Type</option>
											<option value="Candidate">Candidate</option>
											<option value="Institution">Institution</option>
											<option value="Company">Company</option>
											<option value="Recruiter">Recruiter</option>
										</select>
									</div>
								</TabList>

								<div className="content-tab">
									{/* <TabPanel className="inner animation-tab mt-4">
										<h2>Join our Community and Start</h2>
										<h2>Exploring today.</h2>
									</TabPanel> */}
									<TabPanel className="inner animation-tab">
										{selectedDropdownOption === '' && (
											<>
												<h2>Join our Community and Start</h2>
												<h2>Exploring today.</h2>
											</>
										)}
										{selectedDropdownOption === "Institution" && (
											<div>
												<Link
													to="#"
													className="btn-social  mt-2"
													onClick={() => googleSignin()}
												>
													<img src={googleimg} alt="googleimg" /> Continue with
													Google
												</Link>
												<p className="line-ip my-4">
													<span>or</span>
												</p>
												<form action="/">
													<div className="ip">
														<label>
															Institute Email Address<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Email Id"
															value={email}
															// onChange={(e) => setEmail(e.target.value)}
															onChange={handleEmailChange} // Validation on typing
															id="email"
															name="email"
															// className="Input-SignIn"
															className={`Input-SignIn ${emailError ? "error" : ""}`}
															invalid={displays && email === ""}
														/>

														{displays && !email && (
															<span className="error_msg_lbl text-red">
																Please Enter Email Address</span>

														)}
														{emailError && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)}


													</div>
													<div className="ip">
														<label>
															Institute Name<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Institute Name"
															value={firstName}
															onChange={(e) => setFirstName(e.target.value)}
															id="email"
															name="email"
															className="Input-SignIn"
															invalid={displays && firstName === ""}
														// onBlur={() => setDisplays(true)}
														/>
														{displays && !firstName ? (
															<span className="error_msg_lbl text-red">
																Enter Institute Name{" "}
															</span>
														) : null}
													</div>

													<div className="ip">
														<label>
															Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${showPass2 ? "text" : "password"}`}
																className="input-form password-input"
																placeholder="Password"
																required
																id="password-input"
																name="password"
																onChange={handleInstituteChangePassword}
                                                                //value={password2}
																// value={password2}
																// onChange={(e) => setPassword2(e.target.value)}
																//invalid={displays && password2 === ""}
															/>
															{/* {displays && !password2 ? (
																<span className="error_msg_lbl text-red">
																	Enter Password{" "}
																</span>
															) : null} */}

															<Link
																className={`password-addon ${showPass2 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() => setShowPass2(!showPass2)}
															/>
														</div>
														<div> {password2Error && <span className='error_msg_lbl text-red'>{password2Error}</span>}</div>
													</div>

													<div className="ip">
														<label>
															Confirm Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${confirmshowPass2 ? "text" : "password"
																	}`}
																className="input-form password-input"
																placeholder="Confirm Password"
																required
																id="password-input"
																name="password"
																//value={confirmpassword2}
																onChange={(e) =>
																	setconfirmsetPassword2(e.target.value)
																}
																invalid={displays && confirmpassword2 === ""}
															/>
															{displays && !confirmpassword2 ? (
																<span className="error_msg_lbl text-red">
																	Enter Confirm Password{" "}
																</span>
															) : null}

															<Link
																className={`password-addon ${confirmshowPass2 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() =>
																	confirmsetShowPass2(!confirmshowPass2)
																}
															/>
															{/* <div> {password2Error && <span className='error_msg_lbl text-red'>{password2Error}</span>}</div> */}
														</div>
													</div>

													<button
														type="submit"
														onClick={(e) => {
															MailSignUp(e);
														}}
													>
														Register
													</button>
													<div className="group-ant-choice st mt-3"></div>

													{/* <div className="sign-up">
														Already have an account? then Login
													</div> */}
												</form>
											</div>
										)}
										{selectedDropdownOption === "Company" && (
											<div>
												<Link
													to="#"
													className="btn-social  mt-2"
													onClick={() => googleSignin()}
												>
													<img src={googleimg} alt="googleimg" /> Continue with
													Google
												</Link>
												<p className="line-ip my-4">
													<span>or</span>
												</p>
												<form action="/">
													<div className="ip">
														<label>
															Company Email Address<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Email Id"
															value={email}
															// onChange={(e) => setEmail(e.target.value)}
															onChange={handleEmailChange} // Validate on losing focus
															id="email"
															name="email"
															// className="Input-SignIn"
															className={`Input-SignIn ${emailError ? "error" : ""}`}
															invalid={displays && email === ""}
														/>
														{/* {displays && !email ? (
															<span className="error_msg_lbl text-red">
																Enter Email Address{" "}
															</span>
														) : null} */}
														{displays && !email && (
															<span className="error_msg_lbl text-red">
																Please Enter Email Address
															</span>
														)}
														{emailError && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)}

														{/* {displays && email && !email.endsWith("@gmail.com") && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)} */}
													</div>
													<div className="ip">
														<label>
															Company Name<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Company Name"
															value={firstName}
															onChange={(e) => setFirstName(e.target.value)}
															id="email"
															name="email"
															className="Input-SignIn"
															invalid={displays && firstName === ""}
														/>
														{displays && !firstName ? (
															<span className="error_msg_lbl text-red">
																Enter Company Name{" "}
															</span>
														) : null}
													</div>
													<div className="ip">
														<label>
															Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${showPass3 ? "text" : "password"}`}
																className="input-form password-input"
																placeholder="Password"
																required
																id="password-input"
																name="password"
																//onChange={(e) => setPassword3(e.target.value)}
																onChange={handleCompanyChangePassword}
																//value={password3}
																invalid={displays && password3 === ""}
															/>
															{/* {displays && !password3 ? (
																<span className="error_msg_lbl text-red">
																	Enter Password{" "}
																</span>
															) : null} */}

															<Link
																className={`password-addon ${showPass3 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() => setShowPass3(!showPass3)}
															/>
														</div>
														<div> {password3Error && <span className='error_msg_lbl text-red'>{password3Error}</span>}</div>
													</div>
													<div className="ip">
														<label>
															Confirm Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${confirmshowPass3 ? "text" : "password"
																	}`}
																className="input-form password-input"
																placeholder="Confirm Password"
																required
																id="password-input"
																name="password"
																onChange={(e) =>
																	setconfirmsetPassword3(e.target.value)
																}
																//value={confirmpassword3}
																invalid={displays && confirmpassword3 === ""}
															/>
															{displays && !confirmpassword3 ? (
																<span className="error_msg_lbl text-red">
																	Enter Confirm Password{" "}
																</span>
															) : null}

															<Link
																className={`password-addon ${confirmshowPass3 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() =>
																	confirmsetShowPass3(!confirmshowPass3)
																}
															/>
														</div>
														{/* <div> {password3Error && <span className='error_msg_lbl text-red'>{password3Error}</span>}</div> */}
													</div>

													<button
														type="submit"
														onClick={(e) => {
															MailSignUp(e);
														}}
													>
														Register
													</button>
													<div className="group-ant-choice st mt-3"></div>
													{/* <div className="sign-up">
														Already have an account? then Login
													</div> */}
												</form>
											</div>
										)}
										{selectedDropdownOption === "Recruiter" && (
											<div>
												<Link
													to="#"
													className="btn-social  mt-2"
													onClick={() => googleSignin()}
												>
													<img src={googleimg} alt="googleimg" /> Continue with
													Google
												</Link>
												<p className="line-ip my-4">
													<span>or</span>
												</p>
												<form action="/">
													<div className="ip">
														<label>
															Recruiter Email address<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Email Id"
															value={email}
															// onChange={(e) => setEmail(e.target.value)}
															onChange={handleEmailChange} // Validate on losing focus
															id="email"
															name="email"
															// className="Input-SignIn"
															className={`Input-SignIn ${emailError ? "error" : ""}`}
															invalid={displays && email === ""}
														/>
														{/* {displays && !email ? (
															<span className="error_msg_lbl text-red">
																Enter Recruiter Email Address{" "}
															</span>
														) : null} */}
														{displays && !email && (
															<span className="error_msg_lbl text-red">
																Enter Email Address
															</span>
														)}
														{emailError && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)}

														{/* {displays && email && !email.endsWith("@gmail.com") && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)} */}
													</div>
													<div className="ip">
														<label>
															Recruiter Name<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Recruiter Name"
															value={firstName}
															onChange={(e) => setFirstName(e.target.value)}
															id="email"
															name="email"
															className="Input-SignIn"
															invalid={displays && firstName === ""}
														/>
														{displays && !firstName ? (
															<span className="error_msg_lbl text-red">
																Enter Recruiter Name{" "}
															</span>
														) : null}
													</div>
													<div className="ip">
														<label>
															Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${showPass4 ? "text" : "password"}`}
																className="input-form password-input"
																placeholder="Password"
																required
																id="password-input"
																name="password"
																//onChange={(e) => setPassword4(e.target.value)}
																onChange={handleReqruiterChangePassword}
																//value={password4}
																invalid={displays && password4 === ""}
															/>
															{/* {displays && !password4 ? (
																<span className="error_msg_lbl text-red">
																	Enter Password{" "}
																</span>
															) : null} */}

															<Link
																className={`password-addon ${showPass4 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() => setShowPass4(!showPass4)}
															/>
														</div>
														<div> {password4Error && <span className='error_msg_lbl text-red'>{password4Error}</span>}</div>
													</div>
												
													<div className="ip">
														<label>
															Confirm Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${confirmshowPass4 ? "text" : "password"
																	}`}
																className="input-form password-input"
																placeholder="Confirm Password"
																required
																id="password-input"
																name="password"
																onChange={(e) =>
																	setconfirmsetPassword4(e.target.value)
																}
																//value={confirmpassword4}
																invalid={displays && confirmpassword4 === ""}
															/>
															{displays && !confirmpassword4 ? (
																<span className="error_msg_lbl text-red">
																	Enter Confirm Password{" "}
																</span>
															) : null}

															<Link
																className={`password-addon ${confirmshowPass4 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() =>
																	confirmsetShowPass4(!confirmshowPass4)
																}
															/>
														</div>
														{/* <div> {password4Error && <span className='error_msg_lbl text-red'>{password4Error}</span>}</div> */}
													</div>
													<button
														type="submit"
														onClick={(e) => {
															MailSignUp(e);
														}}
													>
														Register
													</button>
													<div className="group-ant-choice st mt-3"></div>
													{/* <div className="sign-up">
														Already have an account? then Login
													</div> */}
												</form>
											</div>
										)}
										{selectedDropdownOption === "Candidate" && (
											<div>
												<Link
													to="#"
													className="btn-social  mt-2"
													onClick={() => googleSignin()}
												>
													<img src={googleimg} alt="googleimg" /> Continue with
													Google
												</Link>
												<p className="line-ip my-4">
													<span>or</span>
												</p>
												<form action="/">
													<div className="ip">
														<label>
															Candidate Email address<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Email Id"
															value={email}
															// onChange={(e) => setEmail(e.target.value)}
															onChange={handleEmailChange} // Validate on losing focus
															id="email"
															name="email"
															// className="Input-SignIn"
															className={`Input-SignIn ${emailError ? "error" : ""}`}
															invalid={displays && email === ""}
														/>
														{/* {displays && !email ? (
															<span className="error_msg_lbl text-red">
																Enter Email Address{" "}
															</span>
														) : null} */}
														{displays && !email && (
															<span className="error_msg_lbl text-red">
																Please	Enter Email Address
															</span>
														)}
														{emailError && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)}

														{/* {displays && email && !email.endsWith("@gmail.com") && (
															<span className="error_msg_lbl text-red">
																Please Enter Valid Email Address
															</span>
														)} */}
													</div>
													<div className="ip">
														<label>
															First Name<span>*</span>
														</label>
														<input
															type="text"
															placeholder="First Name"
															value={firstName}
															onChange={(e) => setFirstName(e.target.value.trim())}
															id="email"
															name="email"
															className="Input-SignIn"
															invalid={displays && firstName === ""}
														/>
														{displays && !firstName ? (
															<span className="error_msg_lbl text-red">
																Enter First Name{" "}
															</span>
														) : null}
													</div>
													<div className="ip">
														<label>
															Last Name<span>*</span>
														</label>
														<input
															type="text"
															placeholder="Last Name"
															value={lastName}
															onChange={(e) => setLastName(e.target.value)}
															id="email"
															name="email"
															className="Input-SignIn"
															invalid={displays && lastName === ""}
														/>
														{displays && !lastName ? (
															<span className="error_msg_lbl text-red">
																Enter Last Name{" "}
															</span>
														) : null}
													</div>
													<div className="ip">
														<label>
															Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${showPass ? "text" : "password"}`}
																className="input-form password-input"
																placeholder="Password"
																required
																id="password-input"
																name="password"
																//onChange={(e) => setPassword(e.target.value)}
																onChange={handleCandidateChangePassword}
																//value={password}
																invalid={displays && password === ""}
															/>
															{/* {displays && !password ? (
																<span className="error_msg_lbl text-red">
																	Enter Password{" "}
																</span>
															) : null} */}

															<Link
																className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() => setShowPass(!showPass)}
															/>
															
														</div>
														<div> {passwordError && <span className='error_msg_lbl text-red'>{passwordError}</span>}</div>
													</div>
													<div className="ip">
														<label>
															Confirm Password<span>*</span>
														</label>
														<div className="inputs-group auth-pass-inputgroup">
															<input
																type={`${showPass1 ? "text" : "password"}`}
																className="input-form password-input"
																placeholder="Confirm Password"
																required
																//value={confirmPassword}
																onChange={(e) =>
																	setConfirmPassword(e.target.value)
																}
																invalid={displays && confirmPassword === ""}
															/>
															{displays && !confirmPassword ? (
																<span className="error_msg_lbl text-red">
																	Enter Confirm Password{" "}
																</span>
															) : null}

															<Link
																className={`password-addon ${showPass1 ? "icon-eye" : "icon-eye-off"
																	}`}
																onClick={() => setShowPass1(!showPass1)}
															/>
														</div>
														{/* <div> {passwordError && <span className='error_msg_lbl text-red'>{passwordError}</span>}</div> */}
													</div>
													<button
														type="submit"
														onClick={(e) => {
															MailSignUp(e);
														}}
													>
														Register
													</button>
													<div className="group-ant-choice st mt-3"></div>
													{/* <div className="sign-up">
														Already have an account? then Login
													</div> */}
												</form>
											</div>
										)}
									</TabPanel>
								</div>
							</Tabs>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default SignUp;
